/* Esse Werks — livery-aware tech-essay cover swapper
   ---------------------------------------------------------------
   Drop a cover into any page with:
     <img data-ew-cover="03-parts-groups" data-ew-format="landscape" alt="...">
   The script points its src at the PNG matching the current livery and
   keeps it in sync when the livery changes.

   Two ways to give it a source (either works — Shopify-friendly):
     A) Render the BASE variant yourself (e.g. Liquid asset_url) as the
        img's src. The script swaps the livery token IN PLACE, preserving
        the host + ?v= cache query:
          src=".../01-chassis-codes-landscape-base.png?v=123"
     B) Give no src and set window.EW_COVERS_BASE to where the PNGs live;
        the script builds "{base}/{cover}-{format}-{livery}.png".

   Livery source: body[data-livery] — "the one global switch" written by
   ew-livery.js (and by the Garage dialog's staged preview, which sets the
   attribute directly without an event — hence the MutationObserver, not
   the ew:livery-changed listener). The theme's livery ids differ from the
   pack's PNG tokens, so LIVERY_MAP translates:
     (unset/null) -> base | performance -> performance
     oemplus -> oem      | drifter     -> drift
   PNG filenames keep the pack tokens (base/performance/oem/drift).

   Config (optional, set before this script loads):
     window.EW_COVERS_BASE = 'https://essewerks.com/cdn/shop/t/2/assets';
*/
(function () {
  var LIVERIES = ['base', 'performance', 'oem', 'drift'];
  var TOKEN = /-(base|performance|oem|drift)(\.(?:png|jpe?g|webp))/i;
  var LIVERY_MAP = { performance: 'performance', oemplus: 'oem', drifter: 'drift' };

  function baseDir() {
    if (window.EW_COVERS_BASE) return String(window.EW_COVERS_BASE).replace(/\/$/, '');
    var s = document.currentScript;
    if (s && s.src) return s.src.replace(/\/[^\/]*$/, '');
    return '.';
  }
  var BASE = baseDir();

  function livery() {
    var l = document.body ? document.body.getAttribute('data-livery') : null;
    return LIVERY_MAP[l] || 'base';
  }

  // Per-image template with a "{LIVERY}" placeholder, computed once.
  function templateFor(img) {
    if (img.__ewTpl) return img.__ewTpl;
    var explicit = img.getAttribute('src') || '';
    var tpl;
    if (TOKEN.test(explicit)) {
      // swap in place — keeps the CDN host, path and ?v= query intact
      tpl = explicit.replace(TOKEN, '-{LIVERY}$2');
    } else {
      var cover = img.getAttribute('data-ew-cover');
      var format = img.getAttribute('data-ew-format') || 'landscape';
      tpl = BASE + '/' + cover + '-' + format + '-{LIVERY}.png';
    }
    img.__ewTpl = tpl;
    return tpl;
  }

  function covers() {
    return document.querySelectorAll('img[data-ew-cover]');
  }

  function apply(liv) {
    covers().forEach(function (img) {
      var next = templateFor(img).replace('{LIVERY}', liv);
      if (img.getAttribute('src') !== next) {
        // Chromium wedge (observed live 2026-07-05): swapping src on a
        // loading=lazy img that hasn't loaded yet can leave it stuck
        // unloaded even once scrolled into view. Real swaps force eager;
        // the base-livery majority never swaps, so index cards stay lazy.
        if (!img.complete || img.naturalWidth === 0) img.loading = 'eager';
        img.src = next;
      }
    });
  }

  function preload(liv) {
    // warm the OTHER three liveries for every cover so a switch is instant
    covers().forEach(function (img) {
      var tpl = templateFor(img);
      LIVERIES.forEach(function (l) {
        if (l === liv) return;
        var im = new Image();
        im.src = tpl.replace('{LIVERY}', l);
      });
    });
  }

  function init() {
    apply(livery());
    if ('requestIdleCallback' in window) {
      requestIdleCallback(function () { preload(livery()); });
    } else {
      window.addEventListener('load', function () { preload(livery()); });
    }
    new MutationObserver(function () { apply(livery()); })
      .observe(document.body, { attributes: true, attributeFilter: ['data-livery'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
